import type { TransferEndpointLocationRow } from "@/lib/transferEndpointLocations";
import {
  OPERATIONAL_LOCATION_NATIVE_SELECT_DIVIDER_VALUE,
  partitionTransferEndpointLocations,
  transferEndpointLocationLabel,
} from "@/lib/transferEndpointLocations";

export function OperationalLocationNativeSelectOptions({
  locations,
  excludeLocationId,
}: {
  locations: readonly TransferEndpointLocationRow[];
  excludeLocationId?: number;
}): JSX.Element {
  const filtered = excludeLocationId == null
    ? locations
    : locations.filter((location) => location.id !== excludeLocationId);
  const { primary, other } = partitionTransferEndpointLocations(filtered);
  const option = (location: TransferEndpointLocationRow) => (
    <option key={location.id} value={String(location.id)}>
      {transferEndpointLocationLabel(location, location.id)}
    </option>
  );
  return (
    <>
      {primary.map(option)}
      {primary.length > 0 && other.length > 0 ? (
        <option disabled value={OPERATIONAL_LOCATION_NATIVE_SELECT_DIVIDER_VALUE}>------------------------</option>
      ) : null}
      {other.map(option)}
    </>
  );
}

export function TransferEndpointLocationSelect({
  locations,
  value,
  onChange,
  disabled,
  emptyLabel,
  excludeLocationId,
  id,
  className,
}: {
  locations: readonly TransferEndpointLocationRow[];
  value: string;
  onChange: (next: string) => void;
  disabled?: boolean;
  emptyLabel?: string;
  excludeLocationId?: number;
  id?: string;
  className?: string;
}): JSX.Element {
  return (
    <select
      id={id}
      value={value}
      disabled={disabled}
      onChange={(event) => onChange(event.target.value)}
      className={
        className
        ?? "h-9 w-full rounded-md border border-slate-300 bg-white px-3 text-sm disabled:opacity-60"
      }
    >
      {emptyLabel != null ? <option value="">{emptyLabel}</option> : null}
      <OperationalLocationNativeSelectOptions locations={locations} excludeLocationId={excludeLocationId} />
    </select>
  );
}
